import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  container: {
    display: 'block',
    width: '100%',
    boxShadow: '0 0.2rem 1rem rgba(0,0,0,0.1)',
    borderTop: '1px solid var(--ui-color-grey-300)',
    borderBottom: '1px solid var(--ui-color-grey-300)',
    textAlign: 'center',
    backgroundColor: 'var(--ui-body-foreground-color)',
  },
  tableNumber: {
    fontWeight: 'bold',
    fontSize: '1.6rem',
    marginTop: '0.5rem',
  },
  button: {
    display: 'block',
    width: '100%',
    textTransform: 'none',
    textAlign: 'center',
    fontSize: '1.4rem',
    padding: 'var(--ui-spacer-s)',
  },
}))

export default useStyles
